import { AbstractFileModel } from "./AbstractFileModel";

/**Базовый класс для импортируемых файлов */
export abstract class AbstractImportFileModel extends AbstractFileModel {
  /**Откуда был импортирован файл */
  SourceUrl!: string;
  /**Файл является импортируемым */
  readonly IsImport: boolean = true;

  constructor(data: Partial<AbstractImportFileModel>) {
    super(data);
    Object.assign(this, data);
  }
}
